module.exports = __webpack_public_path__ + "media/images/icon__infoBox-3bdd5f7e3b668ca3edb4f34b36c78c8e.png";